import { render } from "./CompanyCoursesListView.vue?vue&type=template&id=2c250d42&scoped=true"
import script from "./CompanyCoursesListView.vue?vue&type=script&lang=js"
export * from "./CompanyCoursesListView.vue?vue&type=script&lang=js"

import "./CompanyCoursesListView.vue?vue&type=style&index=0&id=2c250d42&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2c250d42"]])

export default __exports__